(function ($) {

    $.ZagHorizontalOverflow = function (element, options) {

        var options = ValidateOptions(options);

        const container = element[0].querySelector(".zag-horizontal-overflow");
        if (!container) {
            throw new Error("ZagHorizontalOverflow missing container: .zag-horizontal-overflow");
        }

        const window = container.querySelector(".zag-horizontal-overflow__window");
        if (!window) {
            throw new Error("ZagHorizontalOverflow missing window: .zag-horizontal-overflow__window");
        }

        const content = window.querySelector(".zag-horizontal-overflow__content");
        if (!content) {
            throw new Error("ZagHorizontalOverflow missing content: .zag-horizontal-overflow__content");
        }

        container.classList.add("is-active");
        container.insertAdjacentHTML(options.arrowsPlacement, ArrowsHtml());
        const arrows = container.querySelectorAll(".zag-horizontal-overflow__arrow");

        const obj = {
            scrollInterval: null,
            maxScroll: 0,
            options: options,
            container: container,
            window: window,
            content: content,
            arrows: arrows
        };

        Resize(obj);
        Arrows(obj);
        Focus(obj);
    };

    $.fn.ZagHorizontalOverflow = (function (options) {
        return this.each(function () {
            (new $.ZagHorizontalOverflow($(this), options));
        });
    });

    $.ZagHorizontalOverflow.defaultOptions = {
        intervalMs: 10,
        intervalDistance: 5,
        arrowsPlacement: "beforeend"
    };

    function ValidateOptions(options) {
        var options = $.extend({}, $.ZagHorizontalOverflow.defaultOptions, options);
        const validArrowPlacement = ["beforeend", "afterbegin"];

        if (!validArrowPlacement.includes(options.arrowsPlacement))
            throw new Error(`Invalid position: "${options.arrowsPlacement}". Expected "beforeend" or "afterbegin".`);
        return options;
    }

    function Resize(obj) {
        const scrollBarResizeObserver = new ResizeObserver(() => {
            obj.maxScroll = obj.content.scrollWidth - obj.container.clientWidth;
            if (obj.container.clientWidth < obj.content.scrollWidth)
                obj.container.classList.add("is-overflow");
            else
                obj.container.classList.remove("is-overflow");
        });

        scrollBarResizeObserver.observe(obj.container);
        scrollBarResizeObserver.observe(obj.content);
    }

    function StartScroll(obj, arrow) {
        obj.scrollInterval = setInterval(() => {
            Scroll(obj, arrow);
        }, obj.options.intervalMs);
    }

    function StopScroll(obj) {
        if (obj.scrollInterval) {
            clearInterval(obj.scrollInterval);
            obj.scrollInterval = null;
        }
    }

    function Arrows(obj) {
        const keys = ["Enter", " "];

        obj.arrows.forEach(arrow => {

            arrow.addEventListener("pointerdown", event => {
                event.preventDefault();

                if (obj.scrollInterval) return;

                arrow.setPointerCapture(event.pointerId);
                StartScroll(obj, arrow);
            });

            arrow.addEventListener("pointerup", event => {
                arrow.releasePointerCapture(event.pointerId);
                StopScroll(obj);
            });

            arrow.addEventListener("pointercancel", () => {
                StopScroll(obj);
            });

            arrow.addEventListener("mouseleave", () => {
                StopScroll(obj);
            });

            arrow.addEventListener("keydown", event => {
                if (!keys.includes(event.key) || event.repeat) return;
                if (obj.scrollInterval) return;
                StartScroll(obj, arrow);
            });

            arrow.addEventListener("keyup", () => {
                StopScroll(obj);
            });
        });
    }

    function ArrowsHtml() {
        return `
            <div class="zag-horizontal-overflow__arrows">
                <button type="button"
                        class="zag-horizontal-overflow__arrow"
                        data-scroll="left"
                        aria-label="Scroll left">
                    <span>Scroll left</span>
                </button>
                <button type="button"
                        class="zag-horizontal-overflow__arrow"
                        data-scroll="right"
                        aria-label="Scroll right">
                    <span>Scroll right</span>
                </button>
            </div>
        `;
    }

    function Scroll(obj, arrow) {
        const dir = arrow.dataset.scroll;

        if (dir === "right") {
            obj.window.scrollLeft = Math.min(
                obj.window.scrollLeft + obj.options.intervalDistance,
                obj.maxScroll
            );
            if (obj.window.scrollLeft >= obj.maxScroll)
                StopScroll(obj);
        } else if (dir === "left") {
            obj.window.scrollLeft = Math.max(
                obj.window.scrollLeft - obj.options.intervalDistance,
                0
            );
            if (obj.window.scrollLeft <= 0)
                StopScroll(obj);
        }
    }

    function Focus(obj) {
        obj.content.addEventListener("focusin", event => {
            event.target.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "nearest"
            });
        });
    }

})(jQuery);
